
import {
    FETCHED_LABELS,
    FETCHED_LABEL,
    FETCH_LABEL_TYPES,
    CREATED_LABEL,
    UPDATED_LABEL,
    DELETED_LABEL,
    FETCHED_LABEL_TRANSLATIONS,
    FETCHED_LABEL_TRANSLATION,
    DELETED_LABEL_TRANSLATION,
    EDIT_LABELS_TEXT_FIELD_INLINE,
    GET_LABEL_TRANSLATION_FOR_SITE
} from './types';

export function fetchedLabels(data, totalPages) {
    return {
        type: FETCHED_LABELS,
        payload: {
            data: data,
            totalPages: totalPages
        }
    }
}

export function fetchedLabel(label) {
    return {
        type: FETCHED_LABEL,
        label
    };
}

export function fetchedLabelTypes(labelTypes) {
    return {
        type: FETCH_LABEL_TYPES,
        labelTypes
    }
}

export function createdLabel(response) {
    return {
        type: CREATED_LABEL,
        response
    }
}

export function updatedLabel(label) {
    return {
        type: UPDATED_LABEL,
        label
    }
}

export function deletedLabel(labelId) {
    return {
        type: DELETED_LABEL,
        labelId
    }
}

export function fetchedLabelTranslations(labelTranslations) {
    return {
        type: FETCHED_LABEL_TRANSLATIONS,
        labelTranslations
    }
}

export function fetchedLabelTranslation(labelTranslation) {
    return {
        type: FETCHED_LABEL_TRANSLATION,
        labelTranslation
    };
}

export function deletedLabelTranslation(translationId) {
    return {
        type: DELETED_LABEL_TRANSLATION,
        translationId
    }
}

export function getTranslationForSite(siteId) {
    return {
        type: GET_LABEL_TRANSLATION_FOR_SITE,
        siteId
    };
}

export function editTextFieldInline(translatedName) {
    return {
        type: EDIT_LABELS_TEXT_FIELD_INLINE,
        translatedName
    };
}


// WEBPACK FOOTER //
// ./src/containers/labels/actions.js